// The text a screen shows for a failed API call (DT-1855).
//
// Most routes answer a failure as { error: '<text>' }. The shared brand gate (backend utils/brand-access.js
// requireAllowedBrand: 400 'Invalid brand id', 403 'Access denied to this brand') and some controllers answer
// { success: false, message: '<text>' } instead. A screen that reads only data.error then shows axios's own
// "Request failed with status code 403" and the user is never told why.
//
// Order: the server's error, then a refusal's (4xx) message, then axios's own text (unless requestText is
// false), then the fallback. A 5xx message is never shown: some routes still put a caught error's raw text there.
export function apiErrorMessage(err, fallback, { requestText = true } = {}) {
  const res = err?.response;
  const data = res?.data;
  // A string only: some answers carry an object here (index.js malformed-JSON 400 { error: { message, status } }),
  // which a screen would render as a React child and crash.
  if (typeof data?.error === 'string' && data.error) return data.error;
  if (res?.status >= 400 && res?.status < 500 && typeof data?.message === 'string' && data.message) return data.message;
  return (requestText && err?.message) || fallback;
}
